import { Box, useTheme } from "@mui/material";
import Shbutton from "../../../../components/theme/buttons/Shbutton";

import Text from "../../../../components/theme/text/Text";
import { tokens } from "../../../../theme";

import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ShLabel from "../../../../components/theme/label/ShLabel";
import { useGetPortalReturnsWithoutShipmentsThatArePaidQuery, useGetReturnsQuery, useBulkRetryShipmentForReturnMutation, useBulkDeleteFailedReturnsMutation, useBulkReturnShipmentsNewProfileReturnMutation } from "../../../../newapi/inbound/returnsSlice"; // Changed from inboundsSlice to returnsSlice
import { useGetAllReturnShipperProfilesSelectQuery } from "../../../../newapi/shipper/shipperprofileSlice";
// import ReturnsCard from "../../../../components/global/cards/returns/ReturnsCard"; // Changed from InboundsCard to ReturnsCard
import { PhonelinkOutlined, ReplayOutlined, DeleteOutlined, LocalShippingOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { RelationReturnCard } from "../../../../components/global/cards/inbounds/ReturnCards";
import ButtonGroup from "../../../../components/theme/buttons/ButtonGroup";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from "../../../../components/theme/sidepanel2/SidepanelLoader";
import ShLabelSkeleton from "../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetRelationQuery } from "../../../../newapi/global/relation/relationSlice";
import { getReturnStateData } from '../../../../utils/labelColorText';
import { RETURN_FILTER_KEYS } from "../../../../components/global/DataGrid/Filter";
import { return_type } from "../../../../utils/staticEnums";
import { ReactComponent as BolLogo } from '../../../../styles/svg/bol.svg';
import { ReactComponent as ReturnlessLogo } from '../../../../styles/svg/returnless.svg';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import BackHandOutlinedIcon from '@mui/icons-material/BackHandOutlined';
import ShDataGridSelectedActions from "../../../../components/theme/datagrid2/ShDataGridSelectedActions";
import DropdownButton from "../../../../components/theme/buttons/DropdownButton";
import MConfirmation from "../../../../components/global/Modals/MConfirmation";
import MDynamicValues from "../../../../components/global/Modals/MDynamicValues";
import MBulkActionResult from "../../../../components/global/Modals/MBulkActionResult";
import { showToastMessage, showToastMessageUpdateRequest } from "../../../../utils/toasts";
const SpReturnDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpReturnDetails/SpReturnDetails"));

const PaidReturnsWithoutShipments = (props) => { // Changed from InboundInbounds to ReturnReturns
    const { t,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended, setIsExtended] = useState(false);
    const id = useSelector((state) => state.settings.environment.selectedId);
    const [spLoading, setSpLoading] = useState();
    
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);

    let gridOptions = {
        export:true,
        disableCustomActionsOnPhone: true,
        isSidepanel: true,
        filter: [
            RETURN_FILTER_KEYS.PAYMENT, 
            ...(isFulfilment ? [RETURN_FILTER_KEYS.RELATION] : []),
        ],
    };

    // The grid holds both paid and free returns; each row carries its own free flag for labelling.
    const [config] = useState({});

    const [selectedItems, setSelectedItems] = useState([]);

    const [confirmRetryOpen, setConfirmRetryOpen] = useState(false);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [newProfileOpen, setNewProfileOpen] = useState(false);
    const [resultModal, setResultModal] = useState({ open: false, title: "", succeeded: 0, failedIds: [] });
    const [bulkRetryShipment, { isLoading: retryLoading }] = useBulkRetryShipmentForReturnMutation();
    const [bulkDeleteFailedReturns, { isLoading: deleteLoading }] = useBulkDeleteFailedReturnsMutation();
    const [bulkNewProfile, { isLoading: newProfileLoading }] = useBulkReturnShipmentsNewProfileReturnMutation();
    const { data: returnShipperProfiles } = useGetAllReturnShipperProfilesSelectQuery();

    const onSelected = (items) => {
        setSelectedItems(items);
    };

    const handleBulkRetryShipment = async () => {
        if (selectedItems.length === 0) return;
        try {
            const response = await bulkRetryShipment({ returnIds: selectedItems }).unwrap();
            setSelectedItems([]);

            const succeeded = response?.succeeded ?? 0;
            // Every failed return carries the carrier messages and the request body that was sent.
            const failedItems = (response?.results ?? [])
                .filter(r => !r.success)
                .map(r => ({ id: r.returnBarcode ?? r.returnId, error: r.error, errors: r.errors, payload: r.payload }));

            if (failedItems.length === 0) {
                showToastMessage('success', t('bulk_retry_all_succeeded', { count: succeeded, defaultValue: `${succeeded} retour(en) opnieuw verzonden` }));
            } else {
                setResultModal({
                    open: true,
                    title: t('retry_shipment'),
                    succeeded,
                    failedItems,
                });
            }
        } catch (error) {
            showToastMessageUpdateRequest(t, { success: false, error: error?.data?.error ?? error?.data?.message ?? error?.error });
        }
    };

    const handleBulkDeleteFailedReturns = async () => {
        if (selectedItems.length === 0) return;
        try {
            const response = await bulkDeleteFailedReturns({ returnIds: selectedItems }).unwrap();
            setSelectedItems([]);

            const updated = response?.updated ?? 0;
            const skipped = response?.skipped ?? [];

            if (skipped.length === 0) {
                showToastMessage('success', t('bulk_delete_all_succeeded', { count: updated, defaultValue: `${updated} retour(en) verwijderd` }));
            } else {
                setResultModal({
                    open: true,
                    title: t('delete_failed_returns'),
                    succeeded: updated,
                    failedIds: skipped,
                });
            }
        } catch (error) {
            showToastMessageUpdateRequest(t, { success: false, error: error?.data?.error ?? error?.data?.message ?? error?.error });
        }
    };

    const handleBulkNewProfile = async (formValues) => {
        if (selectedItems.length === 0) return;
        if (!formValues?.shipperProfileId) return;
        try {
            const response = await bulkNewProfile({
                returnIds: selectedItems,
                shipperProfileId: formValues.shipperProfileId,
            }).unwrap();
            setSelectedItems([]);

            const succeeded = response?.succeeded ?? 0;
            // Every failed return carries the carrier messages and the request body that was sent.
            const failedItems = (response?.results ?? [])
                .filter(r => !r.success)
                .map(r => ({ id: r.returnBarcode ?? r.returnId, error: r.error, errors: r.errors, payload: r.payload }));

            if (failedItems.length === 0) {
                showToastMessage('success', t('bulk_new_profile_all_succeeded', { count: succeeded, defaultValue: `${succeeded} retour(en) opnieuw verzonden met nieuw profiel` }));
            } else {
                setResultModal({
                    open: true,
                    title: t('retry_with_new_profile', { defaultValue: 'Opnieuw verzenden met ander profiel' }),
                    succeeded,
                    failedItems,
                });
            }
        } catch (error) {
            showToastMessageUpdateRequest(t, { success: false, error: error?.data?.error ?? error?.data?.message ?? error?.error });
        }
    };

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {

        }
    },[props.config]);

    const [relationId, setRelationId] = useState();
    const { data: relation } = useGetRelationQuery(relationId, {
        skip: !relationId
    });
    
    const handlePortalOpen = () => {
        if(!relation){
            setRelationId(id);
        } else {
            window.open(`https://www.clicktoreturn.com/${relation.portalCode}`, '_blank');
        }
    }

    const [returnId, setReturnId] = useState();
    const returnIdRef = useRef(returnId);
    
    const getReturnDetails = (params) => {
        if (!params) return;
    
        const newreturnId = parseInt(params.row.id);
        // Only update state if the returnId has actually changed
        if (returnIdRef.current !== newreturnId) {
            
            if(!spLoading) {
                setSpLoading(true);
            }
            setReturnId(newreturnId);
            returnIdRef.current = newreturnId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const columns = [
        {field: "order", headerName: t("order"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box
                        sx={{
                            display:'flex',
                            alignItems:"center",
                            gap:1.5,
                        }}
                    >
                        {params.row.type === return_type.RETURNPORTAL &&
                            <Box
                                sx={{
                                    flexShrink:0,
                                    width:32,
                                    height:32,
                                    background: colors.orange[100],
                                    borderRadius:4,
                                    display:"flex",
                                    alignItems:'center',
                                    justifyContent:'center',
                                    border: `1px solid ${colors.orange[400]}`,
                                    color: colors.orange[400],
                                }}
                            >
                                <StorefrontOutlinedIcon fontSize="small"/>
                            </Box>
                        }
                        {params.row.type === return_type.RETURNLESS &&
                            <Box
                                sx={{
                                    flexShrink:0,
                                    width:32,
                                    height:32,
                                    background:"#EAEAF9",
                                    borderRadius:4,
                                    display:"flex",
                                    alignItems:'center',
                                    justifyContent:'center',
                                    border: '1px solid #2A2FC1',
                                }}
                            >
                                <ReturnlessLogo width={20}/>
                            </Box>
                        }
                        {params.row.type === return_type.BOL &&
                            <Box
                                sx={{
                                    flexShrink:0,
                                    width:32,
                                    height:32,
                                    background:"#E5E5F5",
                                    borderRadius:4,
                                    display:"flex",
                                    alignItems:'center',
                                    justifyContent:'center',
                                    border: '1px solid #000099',
                                }}
                            >
                                <BolLogo width={20}/>
                            </Box>
                        }
                        {(!params.row.type || params.row.type === return_type.DEFAULT || params.row.type === return_type.UNANNOUNCED) &&
                            <Box
                                sx={{
                                    flexShrink:0,
                                    width:32,
                                    height:32,
                                    background:colors.grey[100],
                                    borderRadius:4,
                                    display:"flex",
                                    alignItems:'center',
                                    justifyContent:'center',
                                    border: `1px solid ${colors.txt["primary"]}`,
                                    color:colors.txt["primary"],
                                    "& svg": {
                                        transform:'rotate(45deg)',
                                    }
                                }}
                            >
                                <BackHandOutlinedIcon fontSize="small"/>
                            </Box>
                        }
                        <Box
                            sx={{
                                width:1,
                                display:'flex',
                                flexDirection:"column",
                            }}
                        >
                            {/* The delivery country rides along with the reference, e.g. "R1111 (NL)". */}
                            <Text>{params.row.order?.barcode ? "R" +params.row.order?.barcode : t("imported")}{params.row.order?.deliveryCountry ? ` (${params.row.order.deliveryCountry.toUpperCase()})` : ""}</Text>
                            <Text fontSize={13} light italic>{params.row.order?.external_reference}</Text>

                        </Box>
                    </Box>
                );
            }
        },
        {field: "name", headerName: t("name"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return(
                    <Text>
                        {params.row.name}
                    </Text>
                )
            }
        },
        {field: "free", headerName: t("type"),flex:1,
            sortable:false,
            filter: RETURN_FILTER_KEYS.PAYMENT,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }
                // Matches the old paid/free toggle: green for paid, blue in dark mode / primary in light for free.
                const freeVariant = theme.palette.mode === "dark" ? "blue" : "primary";
                return (
                    <ShLabel size={32} palette="normal" variant={params.row.free ? freeVariant : "green"}>
                        {params.row.free ? t("free_return") : t("paid")}
                    </ShLabel>
                );
            }
        },
        // {field: "lineCount", headerName: t("sku_count"),flex:1,
        //     sortable:false,
        //     renderCell: (params) => {
        //         if(params.row.skeleton) {
        //             return <ShTextSkeleton/>
        //         }
        //         return params.row.lineCount;
        //     }
        // },        

        {field: "relation", headerName: t("relation"),flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return `${params.row.relation?.name ?? ""}`
                // return params.row.shipperProfile?.name;
            }
        },
        {field: "shipperProfile", headerName: t("shipper_profile"),flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return `${params.row.shipperProfile?.shipper?.name ?? ""} - ${params.row.shipperProfile?.name ?? ""}`
                // return params.row.shipperProfile?.name;
            }
        },
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            // filter: RETURN_FILTER_KEYS.STATE,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const { labelcolor, labeltext } = getReturnStateData(params.row.state, theme);
              
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                  );
              }
        },
        {
            field: "createdAt", 
            headerName: t("created_at"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = new Date(params.row.createdAt);
              
                return (
                    <Box>
                        <Text semibold>
                            {date.toLocaleDateString(i18n.language)}
                        </Text><br/>
                        <Text light>
                            {date.toLocaleTimeString(i18n.language,{timeStyle: 'short'})}
                        </Text>
                    </Box>
                );
            }
        },
        {
            field: "updatedAt", 
            headerName: t("last_updated"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if(params.row.updatedAt === params.row.createdAt || !params.row.order?.barcode){
                    return <Text light></Text>
                }

                let date = new Date(params.row.updatedAt);
              
                return (
                    <Box>
                        <Text semibold>
                            {date.toLocaleDateString(i18n.language)}
                        </Text><br/>
                        <Text light>
                            {date.toLocaleTimeString(i18n.language,{timeStyle: 'short'})}
                        </Text>
                    </Box>
                );
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <RelationReturnCard onClick={() => getReturnDetails(params)} skeleton={params.row.skeleton ?? false} {...params.row}/>
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetPortalReturnsWithoutShipmentsThatArePaidQuery}
                config={config}
                title={t('all_paid_returns_no_shipments') }
                gridOptions={gridOptions}
                sortModel={{field: "createdAt",type:"DESC"}}
                columns={columns}
                onRowClick={getReturnDetails}
                selectable
                setSelected={onSelected}
                keepSelectedAlive
                keepNonExistentRowsSelected
                selectedItems={selectedItems}
                selectedActions={
                    <ShDataGridSelectedActions selectedItems={selectedItems} closeOnChildClick>
                        <DropdownButton
                            onClick={() => setConfirmRetryOpen(true)}
                            icon={<ReplayOutlined/>}
                            text={t("retry_shipment")}
                            disabled={retryLoading}
                        />
                        <DropdownButton
                            onClick={() => setNewProfileOpen(true)}
                            icon={<LocalShippingOutlined/>}
                            text={t("retry_with_new_profile", { defaultValue: "Opnieuw verzenden met ander profiel" })}
                            disabled={newProfileLoading}
                        />
                        <DropdownButton
                            onClick={() => setConfirmDeleteOpen(true)}
                            icon={<DeleteOutlined/>}
                            text={t("delete_failed_returns")}
                            disabled={deleteLoading}
                        />
                    </ShDataGridSelectedActions>
                }
            >
            </ShDataGrid2>

            {spLoading &&
                <SpReturnDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    returnId={returnId}
                />
            }

            <MConfirmation
                open={confirmRetryOpen}
                handleClose={() => setConfirmRetryOpen(false)}
                confirm={handleBulkRetryShipment}
                title={t("retry_shipment")}
                subtitle={t("retry_shipment_confirm")}
            />

            <MConfirmation
                open={confirmDeleteOpen}
                handleClose={() => setConfirmDeleteOpen(false)}
                confirm={handleBulkDeleteFailedReturns}
                title={t("delete_failed_returns")}
                subtitle={t("delete_failed_returns_confirm")}
            />

            <MDynamicValues
                open={newProfileOpen}
                handleClose={() => setNewProfileOpen(false)}
                title={t("retry_with_new_profile", { defaultValue: "Opnieuw verzenden met ander profiel" })}
                subtitle={t("retry_with_new_profile_subtitle", { defaultValue: "Kies een verzendprofiel om de geselecteerde retouren opnieuw te verzenden" })}
                fields={[
                    {
                        name: "shipperProfileId",
                        label: t("shipper_profile"),
                        type: "list",
                        required: true,
                        options: returnShipperProfiles ?? [],
                        search: true,
                    },
                ]}
                onConfirm={handleBulkNewProfile}
            />

            <MBulkActionResult
                open={resultModal.open}
                handleClose={() => setResultModal({ ...resultModal, open: false })}
                title={resultModal.title}
                succeeded={resultModal.succeeded}
                failedIds={resultModal.failedIds}
                failedItems={resultModal.failedItems}
            />

        </Box>
    );
}

export default PaidReturnsWithoutShipments; // Changed from InboundInbounds to ReturnReturns
